export default __webpack_public_path__ + "static/media/logo.514862cc.svg";